const primary = '#50d9e3';
const secondary = '#96f1f8';
const text = '#404a5b';

export default {
  primary,
  secondary,
  text,
};
